import { Link, Navigate } from "react-router";
import { useAuth } from "@client/app/auth";
import { useT } from "@client/i18n";
import { Spinner } from "@client/components/ui";

export function LandingPage() {
  const t = useT();
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" label={t("common.loading")} />
      </div>
    );
  }
  if (user) return <Navigate to="/home" replace />;

  return (
    <main className="mx-auto flex min-h-screen max-w-3xl flex-col justify-center px-4 py-16">
      <p className="text-sm uppercase tracking-wide text-ink-500 dark:text-ink-400">
        {t("landing.codes")}
      </p>
      <h1 className="mt-2 font-display text-4xl text-ink-900 dark:text-ink-50">
        {t("landing.heading")}
      </h1>
      <p className="mt-4 max-w-prose text-lg text-ink-700 dark:text-ink-300">{t("landing.body")}</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link
          to="/register"
          className="inline-flex h-12 items-center rounded-lg bg-accent-700 px-6 font-medium text-white hover:bg-accent-800 dark:bg-accent-600 dark:hover:bg-accent-500"
        >
          {t("landing.ctaRegister")}
        </Link>
        <Link
          to="/login"
          className="inline-flex h-12 items-center rounded-lg border border-ink-300 px-6 font-medium text-ink-800 hover:bg-ink-100 dark:border-ink-700 dark:text-ink-100 dark:hover:bg-ink-800"
        >
          {t("landing.ctaLogin")}
        </Link>
      </div>
    </main>
  );
}

export default LandingPage;
